import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  return (
    <main className="bg-gradient-to-b from-white to-gray-50 min-h-screen flex items-center">
      {/* 🔹 Hero principal */}
      <section className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          {/* Columna izquierda */}
          <div className="inline-block bg-blue-100 text-blue-600 px-4 py-1 rounded-full text-sm font-semibold transition-transform transform hover:scale-105 hover:shadow-md">
            IA para reservas inteligentes
          </div>

          <h1 className="text-5xl font-extrabold mt-6 leading-tight text-gray-900">
            Reservas en segundos con{" "}
            <span className="animated-gradient transition-transform transform hover:scale-105">
              inteligencia artificial
            </span>
          </h1>

          <p className="mt-5 text-gray-600 text-lg">
           Tu restaurante merece estar siempre lleno. Deja que Buksy se encargue de las reservas, mientras tú te encargas de la experiencia.
          </p>

          {/* Botones */}
          <div className="mt-8 flex gap-4">
            {/* ✅ Cambiado a button para evitar warning de href inválido */}
            <button
              type="button"
              className="bg-gradient-to-r from-orange-400 to-red-400 text-white px-8 py-3 rounded-full font-semibold shadow-md hover:opacity-90 hover:scale-105 transition-transform transform hover:shadow-lg"
              onClick={() => window.open('https://form.typeform.com/to/CHIQK53p', '_blank')}
            >
              Empieza Gratis →
            </button>

            <button 
              onClick={() => navigate('/demo')}
              className="px-8 py-3 rounded-full border border-gray-200 text-gray-700 font-medium bg-white hover:bg-gray-50 hover:scale-105 transition-transform transform shadow-sm"
            >
              Ver demo
            </button>
          </div>

          {/* Estadísticas (comentadas hasta tener clientes) */}
          {/*
          <div className="mt-10 flex gap-10 text-center text-sm">
            {[
              { number: "10k+", label: "Reservas realizadas" },
              { number: "500+", label: "Establecimientos" },
              { number: "98%", label: "Satisfacción" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="transition-transform transform hover:scale-105 hover:text-orange-500"
              >
                <span className="text-2xl font-bold text-gray-900">{stat.number}</span>
                <br />
                <span className="text-gray-600">{stat.label}</span>
              </div>
            ))}
          </div>
          */}
        </div>

        {/* Columna derecha */}
        <div className="bg-white shadow-xl rounded-3xl p-8 space-y-5 border border-gray-100">
          {[
            {
              color: "from-blue-500 to-cyan-400",
              icon: "💡",
              title: "IA inteligente",
              desc: "Tus clientes interactúan de manera natural para hacer una reserva en tu restaurante o bar. Nuestra IA buscará confirmación, cancelaciones o reprogramaciones de tus reservas.",
            },
            {
              color: "from-purple-500 to-pink-500",
              icon: "📅",
              title: "Gestión automática",
              desc: "Un CRM que se actualiza de manera automática gracias a nuestra IA, la cual busca mantener una ocupación constante en tu local.",
            },
            {
              color: "from-orange-400 to-yellow-400",
              icon: "🏆",
              title: "Fidelización",
              desc: "Crea planes de fidelización para tus clientes frecuentes y recompensa a quienes cumplen sus reservas con regularidad. Fortalece la relación con tus mejores clientes y aumenta su recurrencia.",
            },
          ].map((f) => (
            <div
              key={f.title}
              className="flex items-center gap-4 bg-gray-50 rounded-2xl p-4 hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              <div
                className={`p-4 rounded-xl bg-gradient-to-r ${f.color} text-white text-lg flex items-center justify-center transition-transform transform hover:scale-110`}
              >
                {f.icon}
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">{f.title}</h3>
                <p className="text-gray-600 text-sm">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
